import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { Grid, MenuItem, Select, Typography, FormControl, FormLabel } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import serviciosSolicitudes from 'utils/serviciosSolicitudes';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import es from 'date-fns/locale/es';
import { format } from 'prettier';
import ListaMiembrosTarea from './ListaMiembrosTarea';
// import { FormControl, FormLabel } from "react-bootstrap";
registerLocale('es', es);

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        height: 140,
        width: 100
    },
    control: {
        padding: theme.spacing(2)
    },
    letraAzul: {
        color: '#1C6BB0'
    }
}));

export default function FormularioTarea(props) {
    const { register, control, errors, defaultItem, ctl, watch, setValue, id, setMensaje, getValues, setCambio, permisos } = props;
    const classes = useStyles();
    const options = [
        { idestatus: 9, label: 'Activo' },
        { idestatus: 10, label: 'Inactivo' }
    ];
    const [startDate, setStartDate] = useState(
        new Date(
            moment(getValues('prop_inicio'))
                .utc()
                .toString()
        )
    );
    const [endDate, setEndDate] = useState(
        new Date(
            moment(getValues('prop_fin'))
                .utc()
                .toString()
        )
    );
    // const [value, setValue] = React.useState(options[0]);
    const [inputValue, setInputValue] = React.useState('');
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fechaActual = year + '-' + month + '-' + day;
    const [cargando, setCargando] = useState(false);

    var fechamin = ctl.infosol?.fecha_inicio;
    var fechamax = ctl.infosol ? (ctl.infosol.fecha_max_ma ? ctl.infosol.fecha_max_ma : ctl.infosol.fecha_fin) : '2090-12-31'; //&& !defaultItem.idtarea
    var fechaMaxFormato = new Date(
        moment(fechamax)
            .utc()
            .toString()
    );
    let suma_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.nhoras_totales), 0);
    let totalHAsignar = parseFloat(ctl.infosol.nhoras_totales) + parseFloat(suma_ma) - parseFloat(ctl.nhorasactual);

    // console.log(endDate);
    const handleChangePrioridad = (event, value) => {
        // console.log(value);
        setValue('prioridad', value);
    };

    const handleChangeM = (event, value) => {
        // console.log(value);
        if (value) {
            setValue('malcance', value);
        } else setValue('malcance', null);
    };
    const handleChange = (event, value) => {
        if (value) {
            setValue('responsables', value);
        } else setValue('responsables', null);
    };
    const handleChangeT = (event, value) => {
        // console.log(event);
        // console.log(value);
        // console.log('estamos en la fehca');
    };

    const handleChangeHoras = (event, value) => {
        // const suma_ma = ctl.infosolMalcance.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.nhoras_totales), 0);
        if (event.target.value) {
            if (defaultItem && defaultItem.idtarea) {
            } else {
                if (
                    parseFloat(event.target.value) + parseFloat(ctl.nhorasactual) <=
                    parseFloat(ctl.infosol.nhoras_totales) + parseFloat(suma_ma)
                ) {
                    setValue('prop_nhoras_tarea', parseFloat(event.target.value));
                } else {
                    // setValue("prop_nhoras_tarea", "0");
                    //mostrar alerta de error
                    setValue('prop_nhoras_tarea', null);
                    setMensaje({
                        open: true,
                        status: '-1',
                        value: 'La adición de este número de horas supera el límite establecido en la propuesta.'
                    });
                }
            }
        }
    };
    const horasAsignadas = watch('responsables')?.reduce((totalHoras, persona) => totalHoras + Number(persona.horas), 0) || 0;
    return (
        <Grid container className={classes.root} spacing={2}>
            <TextField
                error={false}
                defaultValue={id}
                style={{ display: 'none' }}
                id="outlined-error-helper-text"
                label="TÍTULO"
                variant="outlined"
                fullWidth
                name="idsolicitud"
                inputRef={register({
                    required: {
                        value: true,
                        message: 'TÍTULO ES REQUERIDO'
                    },
                    minLength: {
                        value: 1,
                        message: 'MÍNIMO 1 CARÁCTERES'
                    }
                })}
            />

            <Grid item lg={12} xs={12}>
                <TextField
                    defaultValue={defaultItem.titulo}
                    id="outlined-error-helper-text"
                    label="TÍTULO"
                    variant="outlined"
                    fullWidth
                    name="titulo"
                    disabled={defaultItem.titulo ? true : false}
                    inputRef={register({
                        required: {
                            value: true,
                            message: 'TÍTULO ES REQUERIDO'
                        },
                        minLength: {
                            value: 1,
                            message: 'MÍNIMO 1 CARÁCTERES'
                        }
                    })}
                    error={Boolean(errors.titulo)}
                    helperText={errors.titulo}
                />
                {/* <Grid item lg={12} xs={12}>
        <TextField
          defaultValue={defaultItem.titulo}
          id="outlined-error-helper-text"
          label="TÍTULO"
          variant="outlined"
          fullWidth
          name="titulo"
          inputRef={register({
            required: {
              value: true,
              message: "TÍTULO ES REQUERIDO",
            },
            minLength: {
              value: 1,
              message: "MÍNIMO 1 CARÁCTERES",
            },
          })}
          error={Boolean(errors.titulo)}
          helperText={errors.titulo}
        /> */}

                {/* {errors.titulo && <p style={{color:"red"}}>"Campo requerido" </p>} */}
            </Grid>

            <Grid item md={12} xs={12}>
                <Autocomplete
                    options={ctl.prioridad}
                    getOptionLabel={option => option.nprioridad}
                    getOptionSelected={(option, value) => option.idprioridad == value.idprioridad}
                    onChange={handleChangePrioridad}
                    value={watch('prioridad')}
                    size="small"
                    renderInput={params => (
                        <TextField
                            label="PRIORIDAD"
                            variant="outlined"
                            {...params}
                            error={Boolean(errors.prioridad)}
                            helperText={errors.prioridad}
                        />
                    )}
                />
            </Grid>
            {!permisos?.crear_tar_inc && (
                <React.Fragment>
                    {ctl.malcance && ctl.malcance != null && ctl.malcance.length > 0 ? (
                        <Grid item md={12} xs={12}>
                            <Autocomplete
                                options={ctl.malcance}
                                getOptionLabel={option => option.titulo}
                                getOptionSelected={(option, value) => option.idmalcance == value.idmalcance}
                                onChange={handleChangeM}
                                value={watch('malcance')}
                                size="small"
                                // inputRef={register({
                                //   required: {
                                //     value: true,
                                //     message: "CAMPO REQUERIDO",
                                //   },
                                // })}
                                renderInput={params => (
                                    <TextField
                                        label="MODIFICACIÓN DE ALCANCE"
                                        variant="outlined"
                                        {...params}
                                        error={Boolean(errors.malcance)}
                                        helperText={errors.malcance}
                                    />
                                )}
                            />
                        </Grid>
                    ) : (
                        ''
                    )}

                    {/* <Grid item md={12} xs={12}>
          <Autocomplete
            multiple
            options={ctl.personas}
            getOptionLabel={(option) => option.nombre}
            getOptionSelected={(option, value) =>
              option.idpersona == value.idpersona
            }
            value={watch("responsables") || []}
            onChange={handleChange}
            size="small"
            fullWidth
            renderInput={(params) => (
              <TextField
                label="RESPONSABLES"
                variant="outlined"
                {...params}
                error={errors.responsables != undefined}
                helperText={errors.responsables}
              />
            )}
          />
        </Grid>
        */}
                    <Grid item md={12} xs={12}>
                        <ListaMiembrosTarea
                            control={control}
                            name='responsables'
                            rules={{
                                validate:(responsables) => responsables.length > 0 || 'Se debe AGREGAR al menos un miembro para la tarea'
                            }}
                            errors={errors}
                            personas={ctl.personas}
                            totalHAsignar={totalHAsignar}
                            defaultResponsables={defaultItem.responsables}
                        />
                        {/* 
          <Autocomplete
            multiple
            options={ctl.personas}
            getOptionLabel={(option) => option.nombre}
            getOptionSelected={(option, value) => option.idpersona == value.idpersona}
            value={watch('responsables') || []}
            onChange={handleChange}
            size="small"
            fullWidth
            renderInput={(params) => (
              <TextField label="MIEMBROS DEL EQUIPO" variant="outlined" {...params}
                error={errors.persona != undefined} helperText={errors.persona}
              />
            )}
          />
            */}
                    </Grid>
                    <Grid item lg={4} xs={4}>
                        <FormControl>
                            <FormLabel id="date_fecha_inicio">FECHA DE INICIO</FormLabel>
                            <DatePicker
                                locale="es"
                                dateFormat="dd/MM/yyyy"
                                selected={startDate}
                                onChange={date => {
                                    setStartDate(date);
                                    setEndDate(date);
                                    setValue('prop_inicio', moment(date).format('yyyy-MM-DD'));
                                    setValue('prop_fin', moment(date).format('yyyy-MM-DD'));
                                }}
                                name="prop_inicio"
                                filterDate={date => date.getDay() != 0 && date.getDay() != 6}
                                // minDate={new Date(moment( (defaultItem.incidencia == '1'?fechaActual:
                                // (defaultItem.fecha_inicio? defaultItem.fecha_inicio: defaultItem.prop_inicio? defaultItem.prop_inicio: fechamin)) ).utc() ) }
                                // maxDate={ fechaMaxFormato}
                                placeholderText="Fecha inicio"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item lg={4} xs={4}>
                        <FormControl>
                            <FormLabel id="date_fecha_fin">FECHA DE TÉRMINO</FormLabel>
                            <DatePicker
                                locale="es"
                                dateFormat="dd/MM/yyyy"
                                selected={endDate}
                                onChange={date => {
                                    setEndDate(date);
                                    setValue('prop_fin', moment(date).format('yyyy-MM-DD'));
                                }}
                                name="prop_fin"
                                filterDate={date => date.getDay() != 0 && date.getDay() != 6}
                                // minDate={startDate}
                                // maxDate={fechaMaxFormato}
                                placeholderText="Fecha fin"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item lg={4} xs={4}>
                        <Typography variant="caption"># HORAS TRABAJO</Typography>
                        <br />
                        <Typography variant="body1">{horasAsignadas}</Typography>
                    </Grid>
                </React.Fragment>
            )}

            <Grid item lg={12} xs={12}>
                <TextField
                    multiline
                    rows={3}
                    defaultValue={defaultItem.descripcion}
                    id="outlined-error-helper-text"
                    label="DESCRIPCIÓN"
                    variant="outlined"
                    fullWidth
                    name="descripcion"
                    inputRef={register({
                        required: {
                            value: true,
                            message: 'DESCRIPCIÓN ES REQUERIDO'
                        },
                        minLength: {
                            value: 1,
                            message: 'MÍNIMO 1 CARÁCTERES'
                        }
                    })}
                    error={Boolean(errors.descripcion)}
                    helperText={errors.descripcion}
                />
            </Grid>
        </Grid>
    );
}
